"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseCountries = require("nicbase-countries");

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var LanguageForm = function LanguageForm(_ref) {
  var intl = _ref.intl,
      infos = _ref.infos,
      onLanguageChange = _ref.onLanguageChange,
      onNextClick = _ref.onNextClick;

  var _useState = (0, _react.useState)(infos.defaultLanguage),
      _useState2 = _slicedToArray(_useState, 2),
      language = _useState2[0],
      setLanguage = _useState2[1];

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex bg-cyan-500 justify-around items-center h-full w-full text-primary"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "sm:w-1/2 lg:w-1/3 xl:w-1/4 bg-white pt-5 pl-12 pr-12 pb-5 flex flex-col text-base rounded"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.NicplaceLogo, {
    height: "90",
    width: "280",
    className: "self-center mb-10"
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.language.header.left"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "font-bold"
    }, value);
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.language.text.left"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "my-5"
    }, value);
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Dropdown, {
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "portal.registration.language.dropdown.label",
      tagName: "span"
    }),
    source: Object.keys(_nicbaseCountries.LanguageMapping).map(function (key) {
      return {
        value: key,
        label: intl.formatMessage({
          id: _nicbaseCountries.LanguageMapping[key]
        })
      };
    }).sort(function (a, b) {
      return a.label.localeCompare(b.label);
    }),
    value: language,
    onChange: function onChange(e) {
      setLanguage(e);
      onLanguageChange(e);
    }
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
    onClick: (0, _react.useCallback)(function () {
      onNextClick(language);
    }, [language, onNextClick]),
    className: "w-2 self-center my-4",
    primary: true,
    raised: true
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.language.button",
    tagName: "span"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hidden sm:block w-2/5 text-base text-white font-bold"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.language.header.right"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("h3", {
      className: "uppercase text-4xl mb-8"
    }, value);
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.language.text.right"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("h3", {
      className: "text-xl mb-8"
    }, value);
  })));
};

var noop = function noop() {};

LanguageForm.propTypes = {
  intl: _nicbaseTranslation.intlShape.isRequired,
  infos: _propTypes["default"].shape({
    defaultLanguage: _propTypes["default"].string,
    trans: _propTypes["default"].string
  }),
  onLanguageChange: _propTypes["default"].func,
  onNextClick: _propTypes["default"].func
};
LanguageForm.defaultProps = {
  onLanguageChange: noop,
  onNextClick: noop,
  infos: {
    defaultLanguage: 'en-GB',
    trans: ''
  }
};

var _default = (0, _nicbaseTranslation.injectIntl)(LanguageForm);

exports["default"] = _default;